import { render, staticRenderFns } from "./CCustomerStatementDetails.vue?vue&type=template&id=69e41288&scoped=true"
import script from "./CCustomerStatementDetails.vue?vue&type=script&lang=ts"
export * from "./CCustomerStatementDetails.vue?vue&type=script&lang=ts"
import style0 from "./CCustomerStatementDetails.vue?vue&type=style&index=0&id=69e41288&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69e41288",
  null
  
)

export default component.exports